<template>
  <transition name="fade">
    <div class="d-flex justify-content-center mb-3 bg" v-if="show">
      <b-spinner class="m-5" label="Spinning"></b-spinner>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'spinner-filter',
  props: {
    show: Boolean
  }
}
</script>

<style lang="scss" scoped>
.bg {
  z-index: 9999;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.8);
  width: 500px; // TODO 100%は全体になって無理
  height: 100%;
}

.fade-enter-active,
.fade-leave-active{
  transition: all .3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
